const ReportsView = () => {
    return (
        <iframe 
            height="100%"
            width="100%"
            src="https://lookerstudio.google.com/embed/reporting/983164c6-2ae8-41e4-8e47-8d94250153e9/page/y69ZB"
            allowFullScreen
            frameBorder="0" 
            style={{border: 0}}
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox">
        </iframe>
    )
}

export default ReportsView;
